import React from "react";

import { makeStyles } from "@material-ui/core";
import { clsx } from "clsx";

const useStyle = makeStyles((theme) => {
  return {
    root: (props) => ({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      margin: theme.spacing(1.5),
      ...props?.styles?.root,

      [theme.breakpoints.down("lg")]: {
        flexWrap: "wrap",
      },
    }),
    headerClass: (props) => ({
      fontSize: 24,
      fontWeight: 700,
      margin: 0,
      color: "rgba(54, 43, 115, 1)",
      ...props?.styles?.labelClass,
    }),
    labelClass: (props) => ({
      fontSize: 20,
      fontWeight: 700,
      margin: 0,
      opacity: 0.6,
      ...props?.styles?.labelClass,
    }),
  };
});

export default function DashboardCardHeader(props) {
  const classes = useStyle(props);

  return (
    <div className={clsx(classes.root, props.className)}>
      <p className={props.label ? classes.headerClass : classes.labelClass}>
        {props.label ? props.label : "Geography Filters"}
        {props.subLabel && (
          <span style={{ fontWeight: 300 }}>{props.subLabel}</span>
        )}
      </p>
      {props.children}
    </div>
  );
}
